Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.DateRange = (function () {

    function DateRange () {

        Monet.UI.Fields.DateField.apply (this, arguments);

        var baseElement = null;

        this.value = {
            ini: '',
            fin: ''
        };

        this.createElement = function () {

            if(!baseElement){

                this.inputIni = document.createElement('input');
                this.inputFin = document.createElement('input');

                this.inputIni.type = 'text';
                this.inputIni.className = 'dateField';

                this.inputFin.type = 'text';
                this.inputFin.className = 'dateField';

                if(this.maxSize){
                    this.inputIni.maxLength = this.maxSize;
                    this.inputFin.maxLength = this.maxSize;
                }

                this.setInputValue();

                baseElement = this.inputIni;

                this.rootEl.appendChild (this.inputIni);
                this.rootEl.appendChild (this.inputFin);
            }

        };

        this.getValue = function () {

            var result = {
                ini: '',
                fin: ''
            };

            if((this.inputIni && this.inputFin)){
                if (this.inputIni.value) {
                    result.ini = Monet.Format.Date.parseLocaleToISOString(this.inputIni.value);
                }
                if(this.inputFin.value) {
                    result.fin = Monet.Format.Date.parseLocaleToISOString(this.inputFin.value);
                }
            }
            this.value = result;
            return this.value;

        };

        this.isEmpty = function () {
            return !(this.getValue() && this.getValue().ini && this.getValue().fin);
        };

        this.setValue = function (values) {
            if(values){
                this.value.ini = values.ini;
                this.value.fin = values.fin;
                this.setInputValue();
            }
        };

        this.getSafeDate = function () {
            const isValidDateInit = moment(this.value.ini).isValid();
            const isValidDateEnd = moment(this.value.fin).isValid();

            const valueInit = isValidDateInit 
                ? this.value.ini : Monet.Format.Date.getTodayISOString({ daysOffset: -1 });
            const valueFinish = isValidDateEnd 
                ? this.value.fin : Monet.Format.Date.getTodayISOString();

            return {
                valueInit,
                valueFinish
            };
        };

        this.setInputValue = function () {
            if (this.inputIni && this.inputFin) {
                const { valueInit, valueFinish } = this.getSafeDate();
                this.inputIni.value = Monet.Format.Date.formatToLocale(valueInit);
                this.inputFin.value = Monet.Format.Date.formatToLocale(valueFinish);
            }
        };

        this.clear = function (){
            this.setValue({
                ini: '',
                fin: ''
            });
        };

        this.disable = function () {
            this.inputIni.disabled = true;
            this.inputFin.disabled = true;
        };

        this.enable = function () {
            this.inputIni.disabled = false;
            this.inputFin.disabled = false;
        };

        this.initializeSpecialBehavior = function () {

            const monetDateFormat = Monet.I18n.locale.dateFormat.toLowerCase();
            this.jdDateFormat = monetDateFormat.replace("yyyy", "yy");

            const options = {
                dateFormat: this.jdDateFormat,
                beforeShow: () => {
                    $('main').append($('#ui-datepicker-div'));
                },
            };

            if (this.onSelectCallback) {
                options.onSelect = this.onSelectCallback;
            }

            this.setListenerFocusOnEntityField(this.inputFin);

            $(this.inputFin).datepicker(options);

            options.onSelect = options.beforeShow = (input, dpInst) => {
                $('main').append($('#ui-datepicker-div'));
                this.onSelectCallback && this.onSelectCallback();
                this.focusNext('td[data-handler="selectDay"] a.ui-state-default', dpInst);
            };

            this.setListenerFocusOnEntityField(this.inputIni);

            $(this.inputIni).datepicker(options);

        };

        this.render = function (props) {
          this.createElement();
          if (props) {
            if (props.onSelectCallback) {
              this.setOnSelectCallback(props.onSelectCallback);
            }

            if (props.rootClassName) {
              this.rootEl.className = props.rootClassName;
            }
          }
          this.initializeSpecialBehavior();
          return this.rootEl;
        };

    }

    return DateRange;

}());
